import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiCheckCircle, FiClock, FiShield } = FiIcons;

function Hero() {
  const scrollToCurriculum = () => {
    document.getElementById('curriculum')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero-orb hero-orb-one" />
      <div className="hero-orb hero-orb-two" />
      <motion.div
        className="container hero-inner"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65 }}
      >
        <span className="eyebrow">Online Classes for Medical Billing & Coding</span>
        <h1>Medical Coding Classes Online — <em>No Signup!</em></h1>
        <p className="hero-copy">
          Self-paced mini-lessons, interactive flashcards, and practice quizzes to help you master CPT,
          ICD-10, and revenue cycle basics before committing to expensive certification programs.
        </p>

        <div className="benefit-badges" aria-label="Key benefits">
          <span><SafeIcon icon={FiCheckCircle} /> No Sign-Up Required</span>
          <span><SafeIcon icon={FiClock} /> Self-Paced Practice</span>
          <span><SafeIcon icon={FiShield} /> Core Industry Concepts</span>
        </div>

        <button className="primary-cta" onClick={scrollToCurriculum}>
          Explore the Curriculum <SafeIcon icon={FiArrowDown} />
        </button>
        <p className="hero-note">Start anywhere. Your progress is saved on this device.</p>
      </motion.div>
    </section>
  );
}

export default Hero;